/* eslint-disable */
import { useMemo, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";

import JoditEditor from "jodit-react";

/*import url and gateway methods */
import { uploadSingleFile } from "utils/Gateway";
import * as url from "helper/UrlHelper";

//import download file
import fileDownloadHandler from "helper/DownloadFile";
import paymentDuaritonOption from "data/Prod/PaymentDuration.json";
import { assetImages } from "constants";
import JoditEditorField from "components/Common/JoditEditorField/JoditEditorField";
import { getCustomStyles } from "Config/Config";
import FileUploadField from "components/Common/FileUploadField/FileUploadField";

const BioDataAccordion = ({
  resumeTitle = "",
  setresumeTitle,
  resumeSummary = "",
  setresumeSummary,
  resumeDetails = "",
  setresumeDetails,
  minSalary = "",
  setminSalary,
  maxSalary = "",
  setmaxSalary,
  paymentDuration = null,
  setpaymentDuration,
  openDocFileInput,
  docFileInputRef,
  docResumeUploadHandler,
  docFileUploading = false,
  loadingCircle = [],
  uploadedDocFiles = [],
  closeDocFileHandler,
  openVideoFileInput,
  videoFileInputRef,
  videoResumeUploadHandler,
  videoUploading = false,
  uploadedVideoFiles = [],
  closeVideoFileHandler,
  ownerComment = "",
  setOwnerComment,
  customerComment = "",
  setCustomerComment,
}) => {
  const { t } = useTranslation();
  const params = useParams();

  const editor = useRef(null);

  const token = localStorage.getItem("token"); // token

  // const editorCustomConfig = joditEditorConfig();
  const editorCustomConfig = {
    readonly: false,
    placeholder: "",
    minHeight: 300,
    uploader: {
      insertImageAsBase64URI: false,
    },
    events: {
      afterPaste: async (event) => {
        // take the saved clipboard data
        const clipboardData = event.clipboardData || window.clipboardData;
        const items = clipboardData.items;

        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            const file = items[i].getAsFile();

            // Rename the file using a timestamp
            const timestamp = Date.now();
            const fileExtension = file.type.split("/")[1]; // Get the file extension (e.g., png, jpeg)
            const newFileName = `image-${timestamp}.${fileExtension}`;

            const renamedFile = new File([file], newFileName, {
              type: file.type,
            });

            try {
              // upload the file data in server
              const requestUrl =
                url.API_BASE_URL +
                url.API_SINGLE_FILE_UPLOAD +
                `?token=${token}`;

              const response = await uploadSingleFile(requestUrl, renamedFile);

              if (response.status) {
                const imageUrl = url.SERVER_URL + response.data.path;
                // console.log("imageUrl", imageUrl);

                // Replace blob URL with the server URL
                const editorInstance = editor.current;

                if (editorInstance) {
                  const content = editorInstance.value;
                  const regex = /<img[^>]+src="data:image\/[^">]+"/g;
                  const newContent = content.replace(regex, (match) => {
                    const base64DataMatch = match.match(/src="([^"]+)"/);
                    if (
                      base64DataMatch &&
                      base64DataMatch[1].startsWith("data:image/")
                    ) {
                      return match.replace(base64DataMatch[1], imageUrl);
                    }
                    return match;
                  });

                  // add in editor content
                  editorInstance.value = newContent;

                  // add in state content
                  setresumeDetails(newContent);
                }
              }
            } catch (error) {
              console.error("Image upload failed:", error);
            }
          }
        }
      },
    },
    defaultActionOnPaste: "insert_as_html",
    defaultLineHeight: 1.5,
    enter: "div",
    statusbar: false,
    sizeLG: 900,
    sizeMD: 700,
    sizeSM: 400,
    toolbarAdaptive: false,
    disablePlugins: [
      "image",
      "video",
      "about",
      "classSpan",
      "file",
      "speechRecognize",
      "copyformat",
      "spellcheck",
      "add-new-line",
    ],
  };

  const editorConfig = useMemo(() => editorCustomConfig, []);

  return (
    <div className="accordion-item bg-transparent border-0">
      {/* ------ toggle accordion button start ------ */}
      <h3 className="accordion-header">
        <button
          className="accordion-button bg-transparent p-0 shadow-none"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#panelsStayOpen-collapseTwo"
          aria-expanded="true"
          aria-controls="panelsStayOpen-collapseTwo"
        >
          {t("Biodata/CV")}
        </button>
      </h3>
      {/* ------ toggle accordion button end ------ */}
      <div
        id="panelsStayOpen-collapseTwo"
        className="accordion-collapse collapse show"
      >
        <div className="accordion-body p-0 pt-4">
          {params.id ? (
            <div className="d-flex justify-content-end mb-4">
              <Link
                to={`/admin/crm/lead/cvbuilder/${params.id}`}
                className="btn btn-primary"
              >
                Add/Update CV
              </Link>
            </div>
          ) : null}
          {/* ----- biodata title section start ----- */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <label className="d-block fs-sm fw-semibold mb-2">
              {t("Resume Title")}
            </label>
            <input
              type="text"
              id="resumeTitle"
              className="form-control fs-sm border border-gray-300 shadow-none"
              placeholder={t("Resume Title")}
              value={resumeTitle}
              onChange={(e) => setresumeTitle(e.target.value)}
            />
          </div>
          {/* ----- biodata title section end ----- */}

          {/* ----- biodata summary section start ----- */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <label className="d-block fs-sm fw-semibold mb-2">
              {t("Resume Summary")}
            </label>
            <textarea
              name="resumeSummery"
              id="resumeSummery"
              cols="30"
              rows="5"
              className="form-control fs-sm border border-gray-300 shadow-none"
              placeholder={t("Resume Summary")}
              value={resumeSummary}
              onChange={(e) => setresumeSummary(e.target.value)}
            ></textarea>
          </div>
          {/* ----- biodata summary section end ----- */}

          {/* ----- biodata details section start ----- */}
          <div className="form-group mb-4 p-3 pb-0 border rounded-8 shadow-sm bg-white">
            <JoditEditorField
              label={t("Resume Details")}
              labelClassName="d-block fs-sm fw-semibold mb-2"
              value={resumeDetails}
              onChange={(newContent) => setresumeDetails(newContent)}
              editorHeight={250}
            />
          </div>
          {/* ----- biodata details section end ----- */}

          {/* ------ payment section start ------ */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <div className="d-flex flex-wrap align-items-end">
              <div className="flex-grow-1 mb-3 mb-lg-0 me-lg-3">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Pay Rate")}
                </label>
                <input
                  type="number"
                  className="form-control fs-sm border border-gray-300 shadow-none"
                  placeholder={t("Minimum")}
                  value={minSalary}
                  onChange={(e) => setminSalary(e.target.value)}
                />
              </div>
              <div className="flex-grow-1 mb-3 mb-lg-0 me-lg-3">
                <input
                  type="number"
                  className="form-control fs-sm border border-gray-300 shadow-none"
                  placeholder={t("Maximum")}
                  value={maxSalary}
                  onChange={(e) => setmaxSalary(e.target.value)}
                />
              </div>
              <div className="flex-grow-1 mb-3 mb-lg-0 me-lg-3">
                <Select
                  placeholder={t("Select Duration")}
                  className="w-100"
                  isClearable
                  options={paymentDuaritonOption}
                  value={paymentDuration}
                  onChange={(val) => {
                    setpaymentDuration(val);
                  }}
                  styles={getCustomStyles()}
                />
              </div>
            </div>
          </div>
          {/* ------ payment section end ------ */}
          {/* ------ upload resume section start ------- */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <div className="row">
              {/* ------ uploaded doc resume section start ----- */}
              <div className="col-lg-6 mb-3 mb-lg-0">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Upload Documents")}
                </label>
                <FileUploadField
                  label={t("Documents")}
                  accept="doc mp4 pdf"
                  onUpload={docResumeUploadHandler}
                  files={uploadedDocFiles}
                  onRemove={closeDocFileHandler}
                  loading={docFileUploading}
                  multiple
                  fileType="document"
                />
              </div>
              {/* ------ uploaded doc resume section end ----- */}
              {/* ------ uploaded video resume section start ----- */}
              <div className="col-lg-6">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Upload Videos")}
                </label>
                {/* <div className="field-container d-flex align-items-center px-3 body-bg rounded-10">
                  <p className="form-control border-0 rounded-0 shadow-none">
                    Mp4, Avi, Mov
                  </p>
                  <Link to="#" onClick={openVideoFileInput}>
                    <span
                      className="d-block upload-file material-symbols-outlined icon-lg cursor-pointer"
                      data-target="uploadResumeVideo"
                    >
                      upload
                    </span>
                  </Link>
                  <input
                    type="file"
                    id="uploadVideoResume"
                    className="d-none"
                    ref={videoFileInputRef}
                    onChange={videoResumeUploadHandler}
                    multiple
                  />
                </div>
                {videoUploading ? (
                  <div className="d-flex align-items-center mt-3 ms-3">
                    <p className="mb-0 me-1">{t("Uploading Videos")}</p>
                    {loadingCircle.map((circle) => {
                      return (
                        <div
                          key={circle}
                          className="spinner-grow mx-1"
                          style={{ height: "6px", width: "6px" }}
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="upload-files mt-3">
                    <label
                      htmlFor="VideoResume"
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      {t("Uploaded Resume")}
                    </label>
                    <ul className="files row gx-2">
                      {uploadedVideoFiles.map((video, index) => {
                        return (
                          <li
                            className="file col-md-4 position-relative"
                            key={index}
                          >
                            <div className="ratio ratio-16x9">
                              <video src={video.path} controls></video>
                            </div>
                            <Link
                              to="#"
                              onClick={() => {
                                closeVideoFileHandler(index);
                              }}
                            >
                              <span className="d-block material-symbols-outlined icon-lg position-absolute top-0 end-0 mt-2 me-2">
                                delete
                              </span>
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )} */}
                <FileUploadField
                  label={t("Videos")}
                  accept="video/mp4"
                  onUpload={videoResumeUploadHandler}
                  files={uploadedVideoFiles}
                  onRemove={closeVideoFileHandler}
                  loading={videoUploading}
                  multiple
                  fileType="document"
                />
              </div>
              {/* ------ uploaded video resume section end ----- */}
            </div>
          </div>
          {/* ------ upload resume section end ------- */}
          {/* ------- customer comment section start ------- */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <label className="d-block fs-sm fw-semibold mb-2">
              {t("Comment on Candidate for Customer")}
            </label>
            <textarea
              cols="30"
              rows="5"
              className="form-control fs-sm border border-gray-300 shadow-none"
              placeholder={t("Comment on Candidate for Customer")}
              value={ownerComment}
              onChange={(e) => {
                setOwnerComment(e.target.value);
              }}
            ></textarea>
          </div>
          {/* ------- customer comment section end ------- */}
          {/* ------- owner comment section start ------- */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <label className="d-block fs-sm fw-semibold mb-2">
              {t("Comment on Candidate for Owner")}
            </label>
            <textarea
              cols="30"
              rows="5"
              className="form-control fs-sm border border-gray-300 shadow-none"
              placeholder={t("Comment on Candidate for Owner")}
              value={customerComment}
              onChange={(e) => {
                setCustomerComment(e.target.value);
              }}
            ></textarea>
          </div>
          {/* ------- owner comment section end ------- */}
        </div>
      </div>
    </div>
  );
};

export default BioDataAccordion;
